import { jsxs as a, jsx as l } from "react/jsx-runtime";
const r = (e) => /* @__PURE__ */ a(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...e,
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          fillRule: "evenodd",
          d: "M17 7V6a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v1H5a3 3 0 0 0-3 3v2.336l1.46.776a19 19 0 0 0 17.09-.005l1.45-.729V10a3 3 0 0 0-3-3zm-7-2a1 1 0 0 0-1 1v1h6V6a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fill: "currentcolor",
          d: "m22 14.617-.55.276a21 21 0 0 1-18.9 0l-.02-.01L2 14.6V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3z"
        }
      )
    ]
  }
);
export {
  r as default
};
